import type { ValidationModalType } from "../components/ValidationModal";

export type AppAlertType = ValidationModalType;

type AlertBridge = {
  showAlert: (
    title: string,
    message?: string,
    type?: AppAlertType,
    autoCloseMs?: number
  ) => void;
  showConfirm: (config: {
    title: string;
    message: string;
    variant?: "default" | "success" | "warning" | "error";
    confirmText?: string;
    cancelText?: string;
    destructive?: boolean;
  }) => Promise<boolean>;
};

let bridge: AlertBridge | null = null;

export function registerAlertBridge(next: AlertBridge): () => void {
  bridge = next;
  return () => {
    if (bridge === next) bridge = null;
  };
}

export function appAlert(
  title: string,
  message?: string,
  type?: AppAlertType,
  autoCloseMs?: number
): void {
  bridge?.showAlert(title, message ?? "", type ?? "info", autoCloseMs);
}

export function appConfirm(config: Parameters<AlertBridge["showConfirm"]>[0]) {
  if (!bridge) return Promise.resolve(false);
  return bridge.showConfirm(config);
}
